import { render, staticRenderFns } from "./Journal.vue?vue&type=template&id=f4cac2e8&"
import script from "./Journal.vue?vue&type=script&lang=ts&"
export * from "./Journal.vue?vue&type=script&lang=ts&"
import style0 from "./Journal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports